import * as NS from './namespace';
import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';


/**
 * Состояние по умолчанию модуля сайдбара
 */
const defaultState: NS.ISidebarState = {
    isOpen: true,
    menu: [],
    adminMenu: [],
    width: undefined,
    widthCollapsed: undefined,
};

/**
 * Модуль сайдбара для хранилища
 */
export const SidebarModule: Module<NS.ISidebarState, NS.ISidebarState> = {
    namespaced: true,
    actions: {
        ...actions,
    },
    getters: {
        ...getters,
    },
    mutations: {
        ...mutations,
    },
    state: {
        ...defaultState,
    },
};